import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { getLanguage } from '@citrite/translate';
import { isToday } from './dateUtils';
import { StyledCell, StyledDate, StyledTodayMarker } from './Day.styled';
export var Day = /*#__PURE__*/function (_React$Component) {
  function Day() {
    var _this;
    _classCallCheck(this, Day);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Day, [].concat(args));
    _defineProperty(_this, "dayRef", /*#__PURE__*/React.createRef());
    return _this;
  }
  _inherits(Day, _React$Component);
  return _createClass(Day, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var label = this.props.date.toLocaleDateString(getLanguage(), {
        weekday: 'long',
        day: 'numeric',
        year: 'numeric',
        month: 'long'
      });
      var onKeyDown = function onKeyDown(e) {
        if (!_this2.props.disabled && e.key === 'Enter') {
          e.preventDefault();
          _this2.props.onClick(_this2.props.date);
        }
      };
      return /*#__PURE__*/React.createElement(StyledCell, {
        ref: this.dayRef,
        inRange: this.props.inRange,
        startOfRange: this.props.startOfRange,
        endOfRange: this.props.endOfRange,
        disabled: this.props.disabled,
        onClick: !this.props.disabled ? function () {
          return _this2.props.onClick(_this2.props.date);
        } : undefined,
        onKeyDown: onKeyDown,
        role: "button",
        "aria-label": label,
        "aria-pressed": this.props.isSelected,
        "aria-disabled": this.props.disabled,
        tabIndex: this.props.tabIndex,
        onFocus: function onFocus() {
          return _this2.props.onFocus(_this2.props.date);
        }
      }, /*#__PURE__*/React.createElement(StyledDate, {
        disabled: this.props.disabled,
        inRange: this.props.inRange,
        inCurrentMonth: this.props.inCurrentMonth,
        isSelected: this.props.isSelected
      }, /*#__PURE__*/React.createElement("div", null, this.props.date.getDate()), /*#__PURE__*/React.createElement(StyledTodayMarker, {
        isToday: isToday(this.props.date),
        isSelected: this.props.isSelected
      })));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.dayRef.current && this.props.isFocused && this.props.tabIndex === 0) {
        this.dayRef.current.focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.dayRef.current && prevProps.tabIndex !== this.props.tabIndex && this.props.tabIndex === 0 && this.props.isFocused) {
        this.dayRef.current.focus();
      }
    }
  }]);
}(React.Component);